import { apiClient } from './apiClient';

export interface Contact {
  id: string;
  displayName: string;
  emailAddresses?: { address: string; name?: string }[];
  businessPhones?: string[];
  mobilePhone?: string;
  homePhones?: string[];
  givenName?: string;
  surname?: string;
  companyName?: string;
  department?: string;
  jobTitle?: string;
  officeLocation?: string;
}

export interface ContactsListResponse {
  success: boolean;
  data: {
    value: Contact[];
    '@odata.count'?: number;
    '@odata.nextLink'?: string;
  };
  message?: string;
}

export interface ContactResponse {
  success: boolean;
  data: Contact;
  message?: string;
}

interface GetContactsParams {
  filter?: string;
  orderby?: string;
  top?: number;
  skip?: number;
  search?: string;
}

export const contactService = {
  getContacts: async (params?: GetContactsParams): Promise<ContactsListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.filter) queryParams.append('$filter', params.filter);
    if (params?.orderby) queryParams.append('$orderby', params.orderby);
    if (params?.top) queryParams.append('$top', params.top.toString());
    if (params?.skip) queryParams.append('$skip', params.skip.toString());
    if (params?.search) queryParams.append('$search', params.search);
    
    const query = queryParams.toString();
    return apiClient.get(`/contacts${query ? '?' + query : ''}`);
  },

  getContactById: async (contactId: string): Promise<ContactResponse> => {
    return apiClient.get(`/contacts/${contactId}`);
  },

  createContact: async (contact: Partial<Contact>): Promise<ContactResponse> => {
    return apiClient.post('/contacts', contact);
  },

  updateContact: async (contactId: string, contact: Partial<Contact>): Promise<ContactResponse> => {
    return apiClient.patch(`/contacts/${contactId}`, contact);
  },

  deleteContact: async (contactId: string): Promise<{ success: boolean; message?: string }> => {
    return apiClient.delete(`/contacts/${contactId}`);
  },
};
